import { render, staticRenderFns } from "./SelectTemplateMailComponent.vue?vue&type=template&id=426fc765"
import script from "./SelectTemplateMailComponent.vue?vue&type=script&lang=js"
export * from "./SelectTemplateMailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports